import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';

const FaqPage = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      category: 'Le concept',
      items: [
        {
          q: "Qu'est-ce qu'un bar à parfums ?",
          a: "C'est une autre façon de vivre le parfum. Contrairement à une parfumerie classique, nous prenons le temps de vous écouter, de vous proposer des fragrances qui vous correspondent et de composer avec vous une expérience olfactive personnalisée. Le parfum se vit, se raconte, se partage.",
        },
        {
          q: 'Quelle est la différence entre Les Iconiques, Les Pépites et Les Audacieux ?',
          a: "Les Iconiques sont nos fragrances intemporelles, accessibles et appréciées de tous. Les Pépites sont des senteurs rares et raffinées, dénichées avec soin. Les Audacieux sont des compositions uniques et avant-gardistes, pour celles et ceux qui osent.",
        },
        {
          q: "Pourquoi vos parfums sont-ils moins chers qu'en parfumerie classique ?",
          a: "Nous avons fait le choix d'un modèle direct et durable : pas d'intermédiaires, pas de packaging surchargé, et un système de recharge qui réduit les coûts. Cela nous permet de proposer des fragrances de très belle qualité à des prix accessibles.",
        },
      ],
    },
    {
      category: 'Les services',
      items: [
        {
          q: 'Comment se déroule une consultation olfactive ?',
          a: "C'est un moment privilégié d'environ 30 à 45 minutes, où nous échangeons sur vos goûts, vos envies, vos souvenirs. À partir de touches à sentir, nous vous guidons vers les fragrances qui résonnent en vous. Aucune obligation d'achat — juste le plaisir de découvrir.",
        },
        {
          q: "Qu'est-ce que la personnalisation sur-mesure ?",
          a: "Pour 5€ supplémentaires, nous composons avec vous une fragrance unique en ajustant les notes, l'intensité et la signature olfactive. Un parfum qui n'appartient qu'à vous.",
        },
        {
          q: 'Comment fonctionne le système de recharges ?',
          a: "Vous gardez votre flacon Harmony et venez simplement le remplir en boutique. C'est plus économique (jusqu'à 15% de réduction) et plus écologique. Tous nos parfums sont rechargeables.",
        },
        {
          q: "Qu'est-ce que l'abonnement mensuel ?",
          a: "Chaque mois, vous recevez ou venez retirer en boutique un flacon nomade de 10 ml de votre fragrance préférée. Pratique, flexible, sans engagement : modifiez ou annulez quand vous voulez.",
        },
      ],
    },
    {
      category: 'En boutique',
      items: [
        {
          q: 'Où êtes-vous situés et quels sont vos horaires ?',
          a: "Nous sommes au Polygone de Béziers, 3 Carrefour de l'Hours, Niveau Écluses. Ouvert du lundi au samedi de 10h à 20h. Fermé le dimanche.",
        },
        {
          q: 'Faut-il prendre rendez-vous ?',
          a: "Vous pouvez venir librement aux horaires d'ouverture. Pour une consultation olfactive approfondie ou une personnalisation sur-mesure, la prise de rendez-vous est conseillée pour que nous puissions vous accorder toute notre attention.",
        },
        {
          q: 'Proposez-vous des cartes cadeaux ?',
          a: "Oui ! Notre carte cadeau est disponible au montant de votre choix, dans un écrin élégant Harmony. Idéale pour offrir la liberté de choisir.",
        },
        {
          q: 'Organisez-vous des ateliers ou des événements privés ?',
          a: "Oui, nous organisons des ateliers olfactifs, des animations en boutique et des événements privés (EVJF, anniversaire, comité d'entreprise...). Rendez-vous sur notre page Événements pour faire une demande.",
        },
      ],
    },
  ];

  let globalIndex = 0;

  return (
    <div className="min-h-screen bg-[#FDFAF4] pb-16">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-[#B8922A]/10 rounded-full mb-6">
            <HelpCircle className="text-[#B8922A]" size={40} />
          </div>
          <p className="text-xs uppercase tracking-[0.3em] text-[#B8922A] mb-4">
            Aide & informations
          </p>
          <h1
            className="text-5xl md:text-6xl font-light mb-4 text-[#5C2018]"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            data-testid="faq-title"
          >
            Questions fréquentes
          </h1>
          <p className="text-[#332724] font-light leading-relaxed">
            Toutes les réponses aux questions que vous nous posez le plus souvent.
          </p>
        </div>

        {faqs.map((section, sIdx) => (
          <div key={sIdx} className="mb-10">
            <h2
              className="text-2xl mb-4 text-[#1E7A6A]"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            >
              {section.category}
            </h2>
            <div className="space-y-3">
              {section.items.map((item) => {
                const idx = globalIndex++;
                const isOpen = openIndex === idx;
                return (
                  <div
                    key={idx}
                    className="bg-white border border-gold rounded-lg overflow-hidden"
                    data-testid={`faq-item-${idx}`}
                  >
                    <button
                      onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                      className="w-full p-5 text-left flex justify-between items-center hover:bg-[#FDFAF4] transition-colors"
                    >
                      <span className="font-medium text-[#5C2018] pr-4">{item.q}</span>
                      {isOpen ? (
                        <ChevronUp size={20} className="text-[#B8922A] flex-shrink-0" />
                      ) : (
                        <ChevronDown size={20} className="text-[#B8922A] flex-shrink-0" />
                      )}
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 text-[#332724] font-light leading-relaxed border-t border-[#B8922A]/10 pt-4">
                        {item.a}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}

        <div className="bg-[#1E7A6A] text-[#FDFAF4] p-8 rounded-2xl text-center mt-12">
          <p className="text-lg font-light mb-2">Une autre question ?</p>
          <a
            href="tel:0467215708"
            className="inline-block text-2xl mt-2"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
          >
            04 67 21 57 08
          </a>
        </div>
      </div>
    </div>
  );
};

export default FaqPage;
